import { render, staticRenderFns } from "./EmailTemplatesListing.vue?vue&type=template&id=5e9f486a"
import script from "./EmailTemplatesListing.vue?vue&type=script&lang=js"
export * from "./EmailTemplatesListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports